/**
 * Les pages, les éléments et les libellés de liste rangent leurs textes par langue. L'éditeur n'en
 * compose qu'une à la fois, celle de l'utilisateur : ses saisies vont toutes sous cette clé, et
 * c'est elle que lisent les modèles quand ils rendent un libellé.
 */
export const LABEL_KEY = 'default';
